import { Chat } from '@mint-sdk/api-ai-assistant';

export const isAiMessage = (
  message: Chat.ChatMessageRecordType,
): message is Chat.AiChatMessageRecordType => {
  return message.message.type === 'ai';
};
